import request from '@/utils/request'

export const login = (loginForm) => {
  return request({
    url: '/api/login',
    method: 'POST',
    data: {
      username: loginForm.username.trim(),
      password: loginForm.password.trim(),
      role: loginForm.role
    }
  })
}